import type { OrderStatus } from '@restaurant/shared';

export const STATUS_STYLE: Record<OrderStatus, { variant: 'warning' | 'secondary' | 'default' | 'success' | 'muted' | 'destructive' | 'outline'; dot: string }> = {
  draft: { variant: 'warning', dot: 'bg-warning' },
  confirmed: { variant: 'secondary', dot: 'bg-sky-500' },
  preparing: { variant: 'default', dot: 'bg-primary' },
  ready: { variant: 'success', dot: 'bg-success' },
  out_for_delivery: { variant: 'success', dot: 'bg-success' },
  completed: { variant: 'muted', dot: 'bg-muted-foreground' },
  cancelled: { variant: 'destructive', dot: 'bg-destructive' },
};

export const ACTION_LABEL: Partial<Record<OrderStatus, string>> = {
  confirmed: 'Confirm',
  preparing: 'Start preparing',
  ready: 'Mark ready',
  out_for_delivery: 'Out for delivery',
  completed: 'Complete',
};

/** Minutes since a timestamp; used to colour cards that are waiting too long. */
export function ageMinutes(iso: string): number {
  return Math.floor((Date.now() - new Date(iso).getTime()) / 60_000);
}
